import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import ContextSelector from './ContextSelector.js';
import { Grid } from '@material-ui/core';
import CreateCancel from '../../atoms/buttons/CreateCancel.js';
import { contextOptions } from '../../../config/simulation.js'
import { handleSnackBar, invokePostService, invokeGetService } from '../../../store/global/actions';
import { validateFormValueType } from '../../../utils/commonUtils.js';


export default function ContextGenerator({ entityId ,type, action, onCancel}) {
    // console.log("ContextGenerator------------------> ", {entityId, type})
    const dispatch = useDispatch();
    const [isFetching, setIsFetching] = useState(false);
    const [isCreating, setisCreating] = useState(false);
    const [contextArray, setContextArray] = useState([]);
    const [simulationData, setSimulationData] = useState([]);
    const [types, setTypes] = useState(contextOptions)
    const [hbx_functions, setHbx_functions] = useState([])
    const [keySchema, setKeySchema] = useState(null);

    useEffect(() => {   
        setIsFetching(true);
        if(entityId != undefined && entityId != null) getContext();
    }, [entityId]);

    const getContext = () => {
        // Conditionally fetching data of context
        dispatch(invokeGetService(type === 'testcase' ? 'getTestcase' : 'getSimulationTestsuite', [entityId])).then((response) => {
            if (response.status == true) {
                const contextData = response.data?.[type]?.context
                if(contextData != undefined) setKeySchema(JSON.stringify(contextData)) 
                setSimulationData(contextData != undefined ? contextData : [])
                setPredefinedFunctions(response.data.predefinedFunctions)
            }
            setIsFetching(false);
        });
    }


    const setPredefinedFunctions = (predefinedFunctions) => {
        setHbx_functions(predefinedFunctions)
        let functions = predefinedFunctions.map( fn => ({ title: fn.function_label, value: fn.function_name }))
        setTypes([...contextOptions, ...functions])
    }


    const onCreate = () => {
        setisCreating(true)
        let filteredContext = contextArray.filter(context => context.key != '' || context.value != '')
        
        const errors = validateFormValueType(filteredContext)

        if(errors){
            showErrorInContextTable(errors)
            if(errors?.length > 0){
                setisCreating(false)
                return;
            }
        }

        // Conditionally submitting data of context
        dispatch(invokePostService(type === 'testcase' ? 'updateTestcaseContext' : 'updateTestsuiteContext', { contextData: filteredContext }, [entityId])).then(response => {
            setisCreating(false)
            if (response.status && response.data !== null) {
                dispatch(handleSnackBar({ open: true, message: response.message, severity: 'success' }));
            } else {
                dispatch(handleSnackBar({ open: true, message: response.message, severity: 'error' }))
            }
        });

    }

    const showErrorInContextTable = (errors) => {
        const editorTable = document.getElementById("json_table_editor")
        const tableRows = editorTable.querySelectorAll("tbody tr")

        tableRows.forEach((tableRow, index) => {
            const keyInput = document.getElementById(`context[context][${index}][key]`)
            let isErrorFree = true

            console.log(errors, index);

            errors.forEach(error => {
                if(keyInput?.value === error?.key){
                    isErrorFree = false;
                    if(!keyInput.parentElement.querySelector('p')){
                        const errorMessage = document.createElement('p')
                        errorMessage.innerText = error.message;
                        errorMessage.style.color = 'red';
                        errorMessage.style.fontFamily = 'Roboto,Helvetica';
                        errorMessage.style.marginBottom = 0;
                        keyInput.parentElement.appendChild(errorMessage)
                    }
                }
            })
            if(isErrorFree){
                const errorMessage = keyInput.parentElement.querySelector('p');
                if(errorMessage){
                    keyInput.parentElement.removeChild(errorMessage)
                }
            }
        })
    }

    
    return (
        <>
            <ContextSelector key={JSON.stringify(types)} keySchema={keySchema} contextOptions={types} setContextArray={setContextArray} isFetching={isFetching} setIsFetching={setIsFetching} simulationData={simulationData} hbx_functions={hbx_functions} />
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }} >
                {<CreateCancel onCreate={onCreate} onCancel={onCancel} createDisable={isFetching || isCreating} content={isCreating ? 'Updating..' : 'Update'} />}
            </Grid>
        </>
    )




}
